import { render, staticRenderFns } from "./LoginInfoBox.vue?vue&type=template&id=0a8ba3a0&scoped=true&"
import script from "./LoginInfoBox.vue?vue&type=script&lang=js&"
export * from "./LoginInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ba3a0",
  null
  
)

export default component.exports